var map = {
	"./assignment.json": 54178,
	"./auth.json": 15021,
	"./common.json": 79802,
	"./course.json": 60790,
	"locales/en/assignment.json": 54178,
	"locales/en/auth.json": 15021,
	"locales/en/common.json": 79802,
	"locales/en/course.json": 60790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24254;